var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTutors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 13.543C7.97589 13.543 9.375 12.1439 9.375 10.418C9.375 8.69208 7.97589 7.29297 6.25 7.29297C4.52411 7.29297 3.125 8.69208 3.125 10.418C3.125 12.1439 4.52411 13.543 6.25 13.543Z",
    fill: "#1E293B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4759 13.2904L10.5072 19.2487V23.0404H2.17383V18.8737C2.18078 17.9686 2.48223 17.0905 3.03261 16.372C3.58298 15.6535 4.35234 15.1337 5.22435 14.8913C6.09636 14.6488 7.02359 14.697 7.86583 15.0283C8.70807 15.3597 9.41951 15.9563 9.89258 16.7279L13.8717 11.957L15.4759 13.2904Z",
    fill: "#1E293B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 2.08398H22.9163V4.16732H8.33301V2.08398ZM12.4997 6.25065H22.9163V8.33398H12.4997V6.25065ZM16.6663 10.4173H22.9163V12.5007H16.6663V10.4173Z",
    fill: "#E2E8F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutors);
export default __webpack_public_path__ + "static/media/tutors.3e818ff2.svg";
export { ForwardRef as ReactComponent };